module.exports = __webpack_public_path__ + "img/gongdan1.be2147a6.jpg";